"use client";

/**
 * P11-10 · "Cookie settings" — re-opens the banner so a stored choice can be
 * changed or withdrawn.
 *
 * Consent that cannot be withdrawn as easily as it was given is not consent, so
 * this is a requirement rather than a convenience. It lives in the footer's
 * legal row, beside the cookie policy P11-11 adds.
 *
 * A `<button>`, not a link: it opens an in-page dialog and goes nowhere. It is
 * also rendered unconditionally by the footer — when the `consentBanner` flag
 * is off nothing listens for the event, so the button would do nothing, which
 * is why the footer gates it rather than this component.
 */
import { useTranslator } from "~/i18n/provider";
import { openConsentSettings } from "./consent-banner";

export function CookieSettingsLink({ className }: { className?: string }) {
  const t = useTranslator();
  return (
    <button
      type="button"
      onClick={openConsentSettings}
      className={
        className ??
        "underline underline-offset-2 hover:no-underline focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[var(--ring)]"
      }
    >
      {t("consent.settings")}
    </button>
  );
}
